import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'

import { defaultPaging } from 'clickNgo/configs/crud'
import { IPartnerRecord } from 'clickNgo/entities/partner/models'
import { ICrudFetchOptions } from 'clickNgo/models/crud/utils'
import { IDataProviderFilter, IDataProviderSort, Logic, Operator } from 'core-components/types'
import { CrudStore } from 'core/types/crudStore'
import Logger from 'core/utils/Logger'

import { mapPartnerRecordFromJBPMyPartners } from '../mapping'

export const fetchUserPartnerList = (
  email: string,
  options?: ICrudFetchOptions
): Promise<IPartnerRecord[]> => {
  const crud = CrudStore.get(CrudStoreItem.FavoritePartners, options?.cacheKey)
  const sortByPartnerName: IDataProviderSort = {
    field: 'PartnerName',
    dir: 'desc',
  }
  const filterByEmail: IDataProviderFilter = {
    logic: Logic.AND,
    filters: [
      {
        field: 'Email',
        operator: Operator.EQUAL,
        value: email,
      },
    ],
  }

  crud.setPaging(options?.paging || defaultPaging)
  crud.setSort(sortByPartnerName)
  crud.setFilter(filterByEmail)
  return crud
    .fetch({
      skipHierarchyFilter: options?.skipHierarchyFilter,
      force: options?.isForce,
      skipTotal: options?.skipTotal,
    })
    .then((data) => {
      if (data && data.items) {
        return data.items.map(mapPartnerRecordFromJBPMyPartners)
      }
      return []
    })
    .catch((err) => {
      Logger.error(err)
      return []
    })
}
